import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { components } from "@/api/schema";
import { RequestError } from "./queries";
import type { Status } from "@/ui/StatusChip";

/** Домашки студента (страницы «домашки» и «ноутбуки»): все задания курса с версией,
 *  последним прогоном и сдачей. */
export type HomeworkItem = components["schemas"]["HomeworkItem"];

export function useMyHomework() {
  return useQuery({
    queryKey: ["me", "homework"],
    queryFn: async () => {
      const { data, error, response } = await api.GET("/me/homework");
      if (!data) {
        const e = error as { error?: string; message?: string } | undefined;
        throw new RequestError(response.status, e?.error ?? "unknown", e?.message ?? "Не удалось загрузить домашки.");
      }
      return data;
    },
    retry: false,
  });
}

/** Статус домашки для чипа: сдача задаёт его, иначе — по ноутбуку. */
export function homeworkStatus(it: HomeworkItem): Status {
  switch (it.submission?.status) {
    case "on_review":
      return "in_review";
    case "changes_requested":
      return "needs_changes";
    case "accepted":
      return "accepted";
  }
  return it.versions > 0 ? "in_progress" : "not_started";
}
